// extracted by mini-css-extract-plugin
module.exports = {"contactUs":"ContactUs_contactUs__1VehL","socialLinks":"ContactUs_socialLinks__2rwjX"};